<!--
 * @Author: gaobin
 * @Date: 2025-05-19 15:34:33
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-06-09 14:48:23
 * @Description: 虚拟根组件
-->
<template>
  <KuRootView />
  <GlobalLoading />
</template>
<script setup></script>
